import { Power0, TimelineLite, Power3 } from 'gsap'

class AgeGate {
  constructor ($el) {
    this.$el = $el

    if( typeof $.cookie === 'undefined' ) {
      $.getScript( 'https://cdnjs.cloudflare.com/ajax/libs/jquery-cookie/1.4.1/jquery.cookie.min.js', () => {
        this.determineDisplay();
      } );
    } else {
      this.determineDisplay();
    }
  }

  determineDisplay () {
    if ($.cookie('ofLegalAge') !== 'true') {
      this.display()
    } else {
      this.onClose()
    }
  }

  display () {
    const timeline = new TimelineLite()

    timeline
      .set(
        $('html, body'),
        { overflow: 'hidden' }
      )
      .to(
        this.$el,
        0.4,
        {
          autoAlpha: 1,
          ease: Power0.easeNone,
        }
      )
      .fromTo(
        this.$el.find('.age-gate__content__inner'),
        0.4,
        {
          autoAlpha: 0,
          y: 40,
        },
        {
          autoAlpha: 1,
          y: 0,
          ease: Power3.easeOut,
        }
      )

    const $enterBtn = this.$el.find('.enter-btn')
    const $checkbox = this.$el.find('#of-legal-age')

    $enterBtn.on('click', (event) => {
      event.preventDefault()
      if (!$checkbox.is(':checked')) {
        alert('You must confirm you are of legal age in order to enter this website.')
        return
      }

      $.cookie('ofLegalAge', 'true', { expires: parseInt( window.app.data.rememberLegalAge ), path: '/' });
      this.hide()
    })
  }

  hide () {
    const timeline = new TimelineLite({ onComplete: this.onClose, onCompleteScope: this })
    timeline
      .set(
        $('html, body'),
        { overflow: 'visible' }
      )
      .to(
        this.$el,
        0.5,
        {
          autoAlpha: 0,
          ease: Power0.easeNone,
        }
      )
  }

  onClose () {
    this.$el.remove()
  }
}

export default AgeGate



// WEBPACK FOOTER //
// ./scripts/components/AgeGate.js